import { CoreContext } from 'context/CoreContext'
import React, { useContext, useState } from 'react'
import { FormText, Title } from 'ui/styled'
import { CompanyButtonContainer, InputContainer, ModalContainer } from './styled'
import Wrapper from '../Wrapper';
import Button from 'components/Form/Button';
import Slider from 'components/Form/Rating';
import Input from 'components/Form/Input';
import useI18n from 'hooks/useI18n';

export default function ModalFeedBack() {

  const { modal, setModal } = useContext(CoreContext)
  const [rating, setRating] = useState(5)

  const [loading, setLoading] = useState(false)

  const { t } = useI18n()

  const [form, setForm] = useState({})
  const formValue = ref => { return form?.[ref] ? form?.[ref] : ''; }
  const changeForm = (value, ref) => { setForm({ ...form, [ref]: value }); }

  const close = () => {
    setModal(null)
  }

  const handleSave = async () => {
    if(typeof modal?.save === 'function'){
      setLoading(true)
      await modal?.save({
        rate: rating,
        feedback: form?.reply
      })
      setLoading(false)
    }
    close()
  }

  return (
    <>
      <Wrapper title={t('give_feedback')} text={t("how_would_you_rate_the_way_this_request_was_handled")}>
        <ModalContainer>

          <Slider value={rating} onChange={setRating} />
          <InputContainer>
            <Input type='textarea' id={'reply'} placeholder={t('add_reply')} holder value={formValue('reply')} onChange={e => changeForm(e.target.value, 'reply')} textarea />
          </InputContainer>

        </ModalContainer>

        <CompanyButtonContainer>
          <Button onClick={close} width={'120px'} outline color='primary' small nospace>{t('cancel')}</Button>
          <Button color="blue" loading={loading} onClick={handleSave} width={'120px'} small between nospace>{t('send')}</Button>
        </CompanyButtonContainer>
      </Wrapper>
    </>
  )
}
